import React from 'react';

import type { IconProps } from '@atlaskit/icon';
import { RovoIcon } from '@atlaskit/logo';

export const RovoLogoIcon = (props: IconProps) => (
	<RovoIcon {...props} appearance="brand" size="small" />
);
